import './webpack-public-path';
import './polyfills';
import {isLauncherPath} from "./launcher/utils/launcher-constants/launcher-constants";
import {isOrbitInQAMode} from './utils/qa-mode-utils';
import {isHybridEmbedded} from "./utils/hybrid-utils";

async function startLauncher(): Promise<void> {
    const module = await import(/* webpackChunkName: "launcher"*/ './startup-launcher');
    module.startLauncher();
}

async function startHybridApp(): Promise<void> {
    if (isOrbitInQAMode()) {
        if (isLauncherPath(window.location.pathname)) {
            await startLauncher();
        } else {
            const module = await import(/* webpackChunkName: "hybrid-qa"*/ './startup-orbit-hybrid-qa');
            await module.startOrbitHybridQA()
        }
    } else {
        const module = await import(/* webpackChunkName: "hybrid-prod"*/ './startup-orbit-hybrid-prod');
        await module.startupOrbitHybridProd();
    }
}

async function startWebApp(): Promise<void> {
    if(isOrbitInQAMode()) {
        if(isLauncherPath(window.location.pathname)) {
            await startLauncher();
        } else {
            import(/* webpackChunkName: "orbit-qa"*/ './startup-orbit-qa').then(module => module.startOrbitQA());
        }
    } else {
        import(/* webpackChunkName: "orbit-prod"*/ './startup-orbit-prod').then(module => module.startOrbitProd());
    }
}

async function startApp(): Promise<void> {
    if(isHybridEmbedded()) {
        await startHybridApp();
    } else {
        await startWebApp();
    }
}

startApp();

